import { FC, useEffect, useReducer } from "react";
import { PublicParams } from "../../domain/enums/PublicParams";
import { useTranslation } from "react-i18next";
import { initialConfirmation, confirmationReducer } from "../../reducers/confirmation-reducer";
import { userServiceFactory } from "../../services/UserServiceImpl";
import { ConfirmationActionTypes } from "../../types/reducers/confirmation-reducer";

const RegistrationConfirmation: FC = () => {
    /**
     * Using native location object because react-router-dom
     *      get not correctly token: replaces '+' to 'spaces'
     * And this bug generated 403 api error (token expired),
     *      but token still does not expired
     */
    const { t } = useTranslation();
    const registrationToken = window.location.search.split(PublicParams.REGISTRATION_TOKEN + "=")[1];
    const [confirmation, confirmationDispatch] = useReducer(confirmationReducer, initialConfirmation);
    useEffect(() => {
        const confirmRegistration = async () => {
            const userService = userServiceFactory();
            const apiResponse = await userService.confirmRegistration(registrationToken);
            confirmationDispatch({
                type: ConfirmationActionTypes.UPDATE_BY_API_RESPONSE,
                nextValue: { apiResponse },
            });
        };
        confirmRegistration();
    }, []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">{t("auth.confirmation.title")}</h2>
            <h3 className="text-lg text-gray-600 mb-6 text-center">
                {t("auth.confirmation.subtitle")}&nbsp;
                <a href="/" className="text-blue-600 hover:underline">
                    {t("auth.confirmation.subtitleLink")}
                </a>
            </h3>
            <div className="text-center text-gray-700">
                {confirmation.inProcess ? (
                    <p className="text-yellow-600 font-medium">{t("auth.confirmation.inProcess")}</p>
                ) : confirmation.entityNotFound ? (
                    <p className="text-red-600 font-medium">{t("auth.confirmation.error")}</p>
                ) : confirmation.alreadyConfirmed ? (
                    <p className="text-blue-600 font-medium">{t("auth.confirmation.alreadyExist")}</p>
                ) : confirmation.tokenExpired ? (
                    <p className="text-red-600 font-medium">{t("auth.confirmation.expired")}</p>
                ) : (
                    <div className="text-green-600 font-medium">
                        <p>{t("auth.confirmation.success")}</p>
                        <a href="/login" className="text-blue-600 hover:underline">
                            {t("auth.confirmation.link")}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RegistrationConfirmation;
